import { render } from "./ManageUserDialog.vue?vue&type=template&id=4bafeb0c&scoped=true"
import script from "./ManageUserDialog.ts?vue&type=script&lang=js"
export * from "./ManageUserDialog.ts?vue&type=script&lang=js"

import "./ManageUserDialog.vue?vue&type=style&index=0&id=4bafeb0c&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/jkm4GJjzS/0/titletool/titletool-nextgen-server/titletool-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bafeb0c"]])

export default __exports__